import Home from './views/Home';
import Test from './views/Test';
import HelloWorld from './views/HelloWorld';
import GsapDemo from './views/GsapDemo';
import ServerClientDemo from './views/ServerClientDemo';

export default () => [
  {
    name: 'home',
    path: '/s/gift-card-rewards/',
    component: Home,
  },
  {
    name: 'home-prod',
    path: '/p/gift-card-rewards/',
    component: Home,
  }
];
